import { useApiQuery } from '@/api/main/query'
import { PaginatedCollection } from '@/api/types'
import { DEFAULT_TAKE } from '@/shared/constants/constants'
import { useDebounce } from '@/shared/hooks'
import { useQueryClient } from '@tanstack/react-query'
import { financesAPI } from '../api/endpoints'
import { FinanceModel, FinanceStatus, TraderFinanceModel } from '../model'

export const useFinances = ({
  status,
  skip,
  take = DEFAULT_TAKE,
}: {
  status: FinanceStatus
  skip: number
  take?: number
}) => {
  const queryClient = useQueryClient()

  const debouncedSkip = useDebounce(skip, 500)
  const effectiveSkip = skip === 0 ? 0 : debouncedSkip

  const queryKey = ['finances', effectiveSkip, take, status]

  const {
    data,
    error,
    isLoading,
    refetch: refetchFinances,
  } = useApiQuery<PaginatedCollection<FinanceModel[] | TraderFinanceModel[]>>(
    queryKey,
    financesAPI.get(),
    {
      status,
      skip: effectiveSkip,
      take,
    }
  )

  const invalidateFinances = () => {
    queryClient.invalidateQueries({ queryKey })
  }

  return {
    data: {
      financesData: data,
      error,
      isLoading: isLoading,
      skip,
      totalItems: data?.count || 0,
      items: data?.items || [],
    },

    loading: {
      isLoading,
    },

    methods: {
      refetchFinances,
      invalidateFinances,
    },
  }
}
